import moment from 'moment'
import qs from 'qs'

import { AudienceDiscoveryAPI } from 'api'
import fetchAudienceResponse from 'constants/demoOrgData/customAudiences/fetchAudiencesResponse'
import Audience from 'types/audience'
import { hasGates } from 'utils/access'

import {
  CustomAudience,
  CustomAudienceSummary,
  CustomAudienceSummaryQuery,
  EditableCustomAudience,
} from './types'

interface FetchAudiencesResponse {
  audiences: CustomAudience[]
}
interface FetchAudiencesResponseV2 {
  audiences: CustomAudienceSummary[]
}
export const fetchAudiences = () => {
  if (hasGates('has_demo_org')) {
    return Promise.resolve({
      data: fetchAudienceResponse,
      status: 200,
      statusText: '',
    })
  } else {
    return AudienceDiscoveryAPI.get<FetchAudiencesResponse>('/custom_audiences')
  }
}

export const fetchAudiencesV2 = (query: CustomAudienceSummaryQuery) => {
  const adjustedQuery = {
    ...query,
    timeBucket: moment(query.timeBucket).add(1, 'day').format('YYYY-MM-DD'),
  }
  return AudienceDiscoveryAPI.get<FetchAudiencesResponseV2>(
    `/custom_audiences/v2?${qs.stringify(adjustedQuery)}`
  )
}

export const createAudience = (
  audience: CustomAudience | EditableCustomAudience
) => {
  if (hasGates('has_demo_org')) {
    return Promise.resolve({
      data: {
        id: 1234,
        name: 'Trends',
        description: '',
        targetAccounts: true,
        utmParams: false,
        conditions: [],
      } as unknown as CustomAudience,
    })
  } else {
    return AudienceDiscoveryAPI.post<CustomAudience>(
      '/custom_audiences',
      audience
    )
  }
}

export const updateAudience = (audience: CustomAudience) => {
  if (hasGates('has_demo_org')) {
    return Promise.resolve()
  } else {
    return AudienceDiscoveryAPI.patch(
      `/custom_audiences/${audience.id}`,
      audience
    )
  }
}

export const deleteAudience = ({ id }: CustomAudience) => {
  if (hasGates('has_demo_org')) {
    return Promise.resolve()
  } else {
    return AudienceDiscoveryAPI.delete(`/custom_audiences/${id}`)
  }
}

export const getTargetingConditionFromAudience = (audience: Audience) =>
  AudienceDiscoveryAPI.post('/audiences/targeting/v2', [audience])
